module.exports = __webpack_public_path__ + "img/u2.ee1999df.png";